import { ApiProblem } from '../api/problem.js';

/** Muestra un error de la API (título, detalle e identificador de traza) sin reinterpretarlo. */
export function ProblemMessage({ error }: { error: unknown }) {
  const problem = error instanceof ApiProblem ? error : undefined;
  return (
    <div role="alert" className="rounded-md border border-red-200 bg-red-50 p-4 text-red-900">
      <p className="font-medium">{problem?.title ?? 'No se pudo completar la operación.'}</p>
      {problem?.detail ? <p className="mt-1 text-sm">{problem.detail}</p> : null}
      {problem?.traceId ? <p className="mt-2 text-xs text-red-700">Referencia para soporte: {problem.traceId}</p> : null}
    </div>
  );
}
